export interface AdminPushMessageFormProps {
  title: string;
  message: string;
  onTitleChange: (value: string) => void;
  onMessageChange: (value: string) => void;
  titleLabel?: string;
  messageLabel?: string;
  titlePlaceholder?: string;
  messagePlaceholder?: string;
  titleRequired?: boolean;
  messageRequired?: boolean;
  messageRows?: number;
}

export function AdminPushMessageForm({
  title,
  message,
  onTitleChange,
  onMessageChange,
  titleLabel = "💬 푸시 알림 제목 입력",
  messageLabel = "💬 푸시 알림 본문 입력",
  titlePlaceholder = "푸시 알림 제목을 입력하세요",
  messagePlaceholder = "푸시 알림 본문을 입력하세요",
  titleRequired = true,
  messageRequired = true,
  messageRows = 5,
}: AdminPushMessageFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {titleLabel}
          {titleRequired && " (필수)"}
        </label>
        <input
          type="text"
          placeholder={titlePlaceholder}
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {messageLabel}
          {messageRequired && " (필수)"}
        </label>
        <textarea
          placeholder={messagePlaceholder}
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500"
          rows={messageRows}
        />
      </div>
    </div>
  );
}
